import "../styles/components/review-list-adaptive.less";

import * as sidebar from "../sidebar";
import {ReviewList} from "modules/reviews/common/model/reviewlist";
import {ReviewListMobile} from "modules/reviews/common/model/reviewlistmobile";
import {MODAL_QUESTION_EDIT} from "../../../core/modals";
import 'modules/reviews/common/components';
import {ensureLoggedIn, UserInfo} from "core/auth";

let isQuestionsPage = false;

export function init(options) {
	const o = {
	    isDetailsPage: false,
        isQuestionsPage: false,
		review: null,
        reviewsFilterArray: [],
        includeSales: false,
		...options
	};

	isQuestionsPage = o.isQuestionsPage;
	const viewModel = new ViewModel(
	    o.reviewsFilterArray,
        o.review,
        o.isDetailsPage,
        o.isQuestionsPage,
        o.includeSales
    );

	sidebar.init(isQuestionsPage ? 'question' : null);

	initCustomSelect();
	initReviewFilters();
	initSearchAmongReviewsButton();
    initAskQuestionButton(viewModel);

	ko.applyBindings(viewModel, $('#reviewsLayout')[0]);
}

function initCustomSelect() {
    $('#reviews-sort-wrapper').find('select[rel=chosen]').chosen();
}

function initReviewFilters() {
    $(() => {
        const form = $('#reviews-filter-wrapper, #reviews-sort-wrapper');

        $('select, input[type=checkbox], input[type=radio]', form).on('change', () => {
            document.location.href = getLink(form);
        });

        $(form).on('submit', () => false);

        $('[name=sort_by]').on('change', () => {
            document.location.href = getLink(form);
        });

        $('#reviews-filter-wrapper .btn-show-more').click(function (e) {
            e.preventDefault();
            $(this).prevAll('.parametric-list:first').removeClass('shortened');
        });
    });
}

function initSearchAmongReviewsButton() {
    $('#searchAmongReviewsButton').click(() => $('#searchPanel').find('input[name=search]').focus());
}

function initAskQuestionButton(viewModel) {
    $('#askQuestionBtn').click(() => {
        ensureLoggedIn(user => MODAL_QUESTION_EDIT.show(null, response => {
            if(response && response.normalizedData) {
                viewModel.reviewList.prependDataItem(response.normalizedData);
                viewModel.reviewListMobile.prependDataItem(response.normalizedData);
            }
        }));
    });
}

// Function copied from legacy code
function getLink(form) {
    if($('[name="source"]', form).val() == 'old') {
        $('[name="with_image"]', form).attr('checked', false).attr('disabled', true);
    }
    else {
        $('[name="with_image"]', form).attr('disabled', false);
    }
    let link = isQuestionsPage ? 'questions' : 'reviews';
    $('input, select', form).each(function () {
        if(this.tagName == 'SELECT' && $(this).val() != "0" ||
            this.tagName == 'INPUT' && $(this).is(':checked')) {
            if($(this).attr('name') == 'shop') {
                if($(this).data('value') != 'all') {
                    link += '/' + 's_' + $(this).data('value');
                }
            } else if($(this).attr('name') == 'category') {
                if($(this).data('value') != 'all') {
                    link += '/' + 'c_' + $(this).data('value');
                }
            } else if($(this).attr('name') == 'package_group') {
                if($(this).data('value') != 'all') {
                    link += '/' + 'pg_' + $(this).data('value');
                }
            } else if($(this).attr('name') == 'comment_count') {
                if($(this).data('value') != '0') {
                    link += '/' + 'cc_' + $(this).data('value');
                }
            } else if($(this).attr('name') == 'source') {
                if($(this).val() != '0') {
                    link += '/' + 'src_' + $(this).val();
                }
            } else if($(this).attr('name') == 'course') {
                if($(this).val() != 'down') {
                    link += '/' + 'cr_' + $(this).val();
                }
            } else if($(this).attr('name') == 'mine') {
                if($(this).val() == 'on') {
                    link += '/' + 'mine';
                }
            } else if($(this).attr('name') == 'forsale') {
                if($(this).val() == 'on') {
                    link += '/' + 'forsale';
                }
            } else if($(this).attr('name') == 'with_image') {
                switch($(this).data('value')) {
                    case 'custom':
                        link += '/' + 'img_custom';
                        break;
                    case 'off':
                        link += '/' + 'img_off';
                        break;
                }
            } else if($(this).attr('name') == 'period') {
                if($(this).data('value') != 'all') {
                    link += '/' + 'p_' + $(this).data('value');
                }
            } else {
                link += '/' + $(this).attr('name') + '/' + $(this).val();
            }
        }
    });

    const search_val = $.trim($('[rel=search-input]').val());
    const has_search = search_val.length > 0;

    if ($("[name=sort_by]").val() !== undefined) {
        var sort_by = $("[name=sort_by]").val();
        if (has_search) {
            if (sort_by != 'default_search') {
                link += '/' + 'sb_' + sort_by;
            }
        } else {
            if (sort_by == "default_search")
                sort_by = "update_date";
            if (sort_by != 'update_date') {
                link += '/' + 'sb_' + sort_by;
            }
        }
    }

    if (has_search) {
        link += '?search=' + search_val;
    }

    $('[class=filter-link]', form).attr('href', link);
    return link;
}

class ViewModel {
    /** @type {ReviewList} */
    reviewList = null;
    /** @type {ReviewListMobile} */
    reviewListMobile = null;

    constructor(reviewsFilterArray, review, isDetailsPage, isQuestionsPage, includeSales) {
    	this.reviewList = new ReviewList({
            infScrollWrapper: $('.review-columns'),
            columns: !isQuestionsPage,
            columnsCount: 4,
            calculateAverageRating: false,
            showImages: !isQuestionsPage,
            showVideos: isQuestionsPage,
            isDetails: isDetailsPage,
            includeSales
		});
        this.reviewListMobile = new ReviewListMobile({
            infScrollWrapper: $('.review-rows'),
            calculateAverageRating: false,
            showImages: !isQuestionsPage,
            showVideos: isQuestionsPage,
            isDetails: isDetailsPage
        });
    	this.reviewList.enableSizWatcher();

    	if(review === null) {
    	    // Load from server
            this.reviewList.load(reviewsFilterArray);
            this.reviewListMobile.load(reviewsFilterArray);
        } else {
    	    // Load data passed through reviews parameter
            this.reviewList.loadFromArray([review]);
            this.reviewListMobile.loadFromArray([review]);
        }
	}
}


// WEBPACK FOOTER //
// ./modules/reviews/page/index.js